<app-download-button #button
                     [entity]="entity"
                     [iconName]=iconName
                     [fill]="fill"
                     [service]="service"
                     [label]="label"
                     [color]="color"
                     [pdfPreviewMode]="pdfPreview"
                     [imagePreviewMode]="imagePreview"
                     [filename]="fileName ? fileName : entity?.originalFilename"
                     [downloadOnRefresh]="downloadOnRefresh"
                     [downloadOnInit]="downloadOnInit"
                     [buildPayload]="buildPayload"
                     [withMargin]="withMargin"
                     [withPadding]="withPadding"
                     [tooltip]="tooltip"
                     (downloadStartedEvent)="downloadStartedEvent.emit($event)">
</app-download-button>
